(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barracambiante"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cl-barra-v4')) {
    customElements.define('cl-barra-v4', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }
      init() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.initPaper(options);
        this.messages = [...this.querySelectorAll('[data-message]')];
        if (this.messages.length < 2) return;
        this.index = Math.max(0, this.messages.findIndex(el => el.classList.contains('is-active')));
        this.delay = Math.max(2000, Number(this.dataset.interval) || 4000);
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = motion.matches;
        this.hovered = false;
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.restart();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.restart();
        }, options);
        this.addEventListener('focusin', () => this.restart(), options);
        this.addEventListener('focusout', () => {
          cancelAnimationFrame(this.focusFrame);
          this.focusFrame = requestAnimationFrame(() => this.restart());
        }, options);
        document.addEventListener('visibilitychange', () => this.restart(), options);
        motion.addEventListener('change', event => {
          this.paused = event.matches;
          this.restart();
        }, options);
        this.restart();
      }
      initPaper(options) {
        this.paperRow = this.querySelector('[data-paper-row]');
        this.paperTrack = this.querySelector('[data-paper-track]');
        this.paperTile = this.querySelector('[data-paper-original]');
        this.paperImage = this.querySelector('[data-paper-image]');
        if (!this.paperRow || !this.paperTile || !this.paperImage) return;
        const update = () => {
          cancelAnimationFrame(this.paperFrame);
          this.paperFrame = requestAnimationFrame(() => this.fillPaper());
        };
        const loaded = () => {
          this.setAttribute('data-image-state', 'loaded');
          update();
        };
        this.paperImage.addEventListener('load', loaded, options);
        const failed = () => {
          const fallback = this.paperImage.dataset.fallbackSrc;
          if (fallback && !this.paperImage.dataset.fallbackTried) {
            this.paperImage.dataset.fallbackTried = 'true';
            this.paperTrack.querySelectorAll('[data-paper-copy]').forEach(copy => copy.remove());
            this.paperTile.querySelectorAll('source').forEach(source => source.remove());
            this.paperImage.removeAttribute('srcset');
            this.paperImage.src = fallback;
            return;
          }
          this.setAttribute('data-image-state', 'error');
        };
        this.paperImage.addEventListener('error', failed, options);
        if (typeof ResizeObserver !== 'undefined') {
          this.paperObserver = new ResizeObserver(update);
          this.paperObserver.observe(this.paperRow);
        }
        window.addEventListener('resize', update, options);
        if (this.paperImage.complete) {
          if (this.paperImage.naturalWidth > 0) loaded();
          else failed();
        }
        update();
      }
      fillPaper() {
        if (!this.isConnected || !this.paperTrack) return;
        const width = this.paperTile.getBoundingClientRect().width;
        if (width < 1) return;
        const count = this.paperRow.dataset.repeat === 'true'
          ? Math.min(48, Math.ceil(this.paperRow.clientWidth / width) + 2)
          : 1;
        const copies = [...this.paperTrack.querySelectorAll('[data-paper-copy]')];
        if (copies.length === count - 1) return;
        copies.forEach(copy => copy.remove());
        for (let i = 1; i < count; i++) {
          const copy = this.paperTile.cloneNode(true);
          copy.removeAttribute('data-paper-original');
          copy.setAttribute('data-paper-copy', '');
          copy.querySelector('[data-paper-image]')?.removeAttribute('data-paper-image');
          this.paperTrack.append(copy);
        }
      }
      restart() {
        clearInterval(this.timer);
        if (!this.isConnected || this.paused || this.hovered || document.hidden || this.contains(document.activeElement)) return;
        this.timer = setInterval(() => {
          this.index = (this.index + 1) % this.messages.length;
          this.messages.forEach((el, index) => {
            const active = index === this.index;
            el.classList.toggle('is-active', active);
            el.setAttribute('aria-hidden', String(!active));
          });
        }, this.delay);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.focusFrame);
        cancelAnimationFrame(this.paperFrame);
        this.paperObserver?.disconnect();
        clearInterval(this.timer);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const carousel = document.querySelector('.collection-carousel');
  const items = document.querySelectorAll('.collection-item');
  const prevButton = document.querySelector('.carousel-prev');
  const nextButton = document.querySelector('.carousel-next');
  
  let currentIndex = 0;

  // Función para mover el carrusel
  function moveCarousel() {
    const itemWidth = items[0].offsetWidth + 20; // Tamaño de los items + gap
    carousel.style.transform = `translateX(-${currentIndex * itemWidth}px)`;
  }

  // Botón "Siguiente"
  nextButton.addEventListener('click', function() {
    if (currentIndex < items.length - 1) {
      currentIndex++;
    } else {
      currentIndex = 0; // Volver al primer item
    }
    moveCarousel();
  });

  // Botón "Anterior"
  prevButton.addEventListener('click', function() {
    if (currentIndex > 0) {
      currentIndex--;
    } else {
      currentIndex = items.length - 1; // Volver al último item
    }
    moveCarousel();
  });
  
  // Mover carrusel cada 3 segundos (auto)
  setInterval(function() {
    nextButton.click();
  }, 3000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("popup-wrapper");
  const content = popup.querySelector(".popup-content");
  const closeBtn = popup.querySelector(".popup-close");
  const images = popup.querySelectorAll(".popup-slider .popup-image");
  const slider = popup.querySelector(".popup-slider");
  const activeLink = document.getElementById("popup-active-link");

  let current = 0;
  let intervalTime = parseInt(content.dataset.slideInterval) * 1000 || 4000;
  let transitionType = content.dataset.transition || "fade";
  let autoCloseTime = parseInt(content.dataset.autoClose) || 0;

  slider.classList.add(transitionType);

  setTimeout(() => {
    popup.classList.add("active");

    if(autoCloseTime > 0){
      setTimeout(() => {
        popup.classList.remove("active");
      }, autoCloseTime * 1000);
    }
  }, 2000);

  closeBtn.addEventListener("click", () => {
    popup.classList.remove("active");
  });

  if(images.length > 1){
    setInterval(() => {
      images[current].classList.remove("active");
      current = (current + 1) % images.length;
      images[current].classList.add("active");

      const link = images[current].dataset.link;
      if(link) activeLink.href = link;
    }, intervalTime);
  }
});

  } catch(e) { console.error(e); }
})();
})();
